import "../../../select.css"
import React, {useState} from "react"
import { train } from "../../../../data/selectOptions"
import ListSelect from "../../ListSelect"
import HunsUpgrade from "./HunsUpgrade"
import EgyptsUpgrade from "./EgyptsUpgrade"
import RomansUpgrade from "./RomansUpgrade"
import GallicUpgrade from "./GallicUpgrade"
import TeutonicUpgrade from "./TeutonicUpgrade"
import SpartansUpgrade from "./SpartansUpgrade"

const Upgrade = (props) => {
    const selectList = train 

    const [selectValue, setSelectValue] = useState("")
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
    }
    function addItemHun (newItem) {
        props.addItem(newItem)
    }
    function addItemEgypt (newItem) {
        props.addItem(newItem)
    }
    function addItemRoman (newItem) {
        props.addItem(newItem)
    }
    function addItemGallic (newItem) {
        props.addItem(newItem)
    }
    function addItemTeutonic (newItem) {
        props.addItem(newItem)
    }
    function addItemSpartans (newItem) {
        props.addItem(newItem)
    }
return (
    <div>
        <ListSelect label="...choose nation..." selectList={selectList} handleSelectValue={handleSelectValue} />
        {selectValue ==="1" ? (
            <HunsUpgrade addItem={addItemHun} />
        ) :
        selectValue ==="2" ? (
            <EgyptsUpgrade addItem={addItemEgypt} />
        ) :
        selectValue ==="3" ? (
            <RomansUpgrade addItem={addItemRoman} />
        ) :
        selectValue ==="4" ? (
            <GallicUpgrade addItem={addItemGallic} />
        ) :
        selectValue ==="5" ? (
            <TeutonicUpgrade addItem={addItemTeutonic} />
        ) :
        selectValue ==="6" ? (
            <SpartansUpgrade addItem={addItemSpartans} />
        ) : null }
    </div>
)
}
export default Upgrade